import { useQuery } from '@tanstack/react-query'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { useAppSelector } from 'common/hooks/redux'

import { getUMVUsage } from '../api'
import { keys } from '../queryKeys'

const useGetUMVUsageQuery = () => {
  const flags = useFlags()
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const getUMVUsageQuery = useQuery({
    queryKey: keys.account(accountId),
    queryFn: () => getUMVUsage(accountId),
    enabled: !!accountId && !!flags.enableUmvUsageTracking,
  })

  return getUMVUsageQuery
}

export default useGetUMVUsageQuery
